import type { HelpTextToken, Theme } from 'hephaestus/core';
import { merge } from 'lodash-es';

export const useHelpTextTokens = (theme: Theme): HelpTextToken => {
  const { color, component } = theme;
  const base = {
    successColor: color.positive,
    errorColor: color.negative,
    warningColor: color.warning,
    neutralColor: color.onSurfaceVariant,
    displayInDialog: true,
  };

  return merge({}, base, component?.helpText) as HelpTextToken;
};
